import type { DeviceCredential } from "../api/types";
import { getBridge } from "../bridge";

// Persisted device identity: the device_id assigned at registration and the
// credential minted at pairing. Stored via the bridge's secure store.

const DEVICE_ID_KEY = "gocityscreens.device.id";
const CREDENTIAL_KEY = "gocityscreens.device.credential";

export async function loadDeviceId(): Promise<string | null> {
  return getBridge().secureStore.get(DEVICE_ID_KEY);
}

export async function saveDeviceId(deviceId: string): Promise<void> {
  await getBridge().secureStore.set(DEVICE_ID_KEY, deviceId);
}

export async function loadCredential(): Promise<DeviceCredential | null> {
  const raw = await getBridge().secureStore.get(CREDENTIAL_KEY);
  if (!raw) return null;
  try {
    return JSON.parse(raw) as DeviceCredential;
  } catch {
    return null;
  }
}

export async function saveCredential(cred: DeviceCredential): Promise<void> {
  await getBridge().secureStore.set(CREDENTIAL_KEY, JSON.stringify(cred));
}

export async function clearIdentity(): Promise<void> {
  const store = getBridge().secureStore;
  await store.remove(CREDENTIAL_KEY);
  await store.remove(DEVICE_ID_KEY);
}
